import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { installSecretHashInterceptor } from './services/cognitoHelper';
import modelIntrospection from './modelIntrospection.json';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Install SECRET_HASH interceptor BEFORE any Cognito calls
installSecretHashInterceptor();

// Configure Amplify with Gen 2 sandbox outputs if available (file is .gitignored)
let amplifyOutputs = null;
try {
  amplifyOutputs = require('./amplify_outputs.json');
} catch (e) {
  // amplify_outputs.json not available — will configure from env vars
}

if (amplifyOutputs) {
  Amplify.configure({
    ...amplifyOutputs,
    data: { ...amplifyOutputs.data, model_introspection: modelIntrospection },
  });
} else if (process.env.REACT_APP_USER_POOL_ID && process.env.REACT_APP_CLIENT_ID) {
  const region = process.env.REACT_APP_REGION || 'eu-north-1';

  console.log('[Amplify] Configuring from env vars:');
  console.log('[Amplify]   User Pool ID:', process.env.REACT_APP_USER_POOL_ID);
  console.log('[Amplify]   Client ID:', process.env.REACT_APP_CLIENT_ID);
  console.log('[Amplify]   AppSync Endpoint:', process.env.REACT_APP_APPSYNC_ENDPOINT || '(not set)');
  console.log('[Amplify]   Region:', region);

  const envConfig = {
    Auth: {
      Cognito: {
        userPoolId: process.env.REACT_APP_USER_POOL_ID,
        userPoolClientId: process.env.REACT_APP_CLIENT_ID,
      },
    },
  };

  if (process.env.REACT_APP_APPSYNC_ENDPOINT) {
    envConfig.API = {
      GraphQL: {
        endpoint: process.env.REACT_APP_APPSYNC_ENDPOINT,
        region: region,
        defaultAuthMode: 'userPool',
        modelIntrospection: modelIntrospection,
      },
    };
  } else {
    console.warn('[Amplify] REACT_APP_APPSYNC_ENDPOINT not set — GraphQL client will not work');
  }

  Amplify.configure(envConfig);
}

// Layer on OAuth config from env vars for Google sign-in
const oauthScopes = process.env.REACT_APP_OAUTH_SCOPES
  ? process.env.REACT_APP_OAUTH_SCOPES.split(/[\s,]+/).filter(Boolean)
  : ['openid', 'email', 'profile'];

const currentRedirect = window.location.origin + '/';

console.log('[Amplify] OAuth scopes:', oauthScopes);
console.log('[Amplify] Cognito domain:', process.env.REACT_APP_COGNITO_DOMAIN);
console.log('[Amplify] Redirect URI:', currentRedirect);

if (process.env.REACT_APP_COGNITO_DOMAIN) {
  const existingConfig = Amplify.getConfig();
  Amplify.configure({
    ...existingConfig,
    Auth: {
      ...existingConfig.Auth,
      Cognito: {
        ...existingConfig.Auth?.Cognito,
        userPoolId: existingConfig.Auth?.Cognito?.userPoolId || process.env.REACT_APP_USER_POOL_ID,
        userPoolClientId: existingConfig.Auth?.Cognito?.userPoolClientId || process.env.REACT_APP_CLIENT_ID,
        loginWith: {
          ...existingConfig.Auth?.Cognito?.loginWith,
          oauth: {
            domain: process.env.REACT_APP_COGNITO_DOMAIN,
            scopes: oauthScopes,
            redirectSignIn: [currentRedirect],
            redirectSignOut: [currentRedirect],
            responseType: 'code',
            providers: ['Google'],
          },
        },
      },
    },
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
